// Normalize hosts so that `www.foodango.pl` and `foodango.pl` match.
const normalizeHost = (host: string): string => host.replace(/^www\./i, "");

const getInternalHost = (): string | null => {
  const base = process.env.NEXT_PUBLIC_BASE_URL;

  if (!base) {
    return null;
  }

  try {
    return normalizeHost(new URL(base).hostname);
  } catch {
    return null;
  }
};

export const isExternalLink = (url: string): boolean => {
  // Relative links (/, #, ?, mailto:, tel:, ...) are always internal.
  if (!/^https?:\/\//i.test(url)) {
    return false;
  }

  try {
    const linkHost = normalizeHost(new URL(url).hostname);
    const internalHost = getInternalHost();

    // Without a configured base URL, treat any absolute http(s) link as external.
    if (!internalHost) {
      return true;
    }

    return linkHost !== internalHost;
  } catch {
    return false;
  }
};
